import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VisibilityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"visibility"}/>
}
